import { Component, Host, h, getAssetPath, Prop } from '@stencil/core';

@Component({
  tag: 'me-footer',
  styleUrl: 'me-footer.scss',
  shadow: false,
  assetsDirs: ['assets'],
})
export class MeFooter {

  @Prop() medienhausLinks = true;

  render() {
    const medienhausClassList = [
      'me-footer__medienhaus',
      this.medienhausLinks ? 'me-footer__medienhaus--active' : null,
    ].filter(c => !!c).join(' ');

    return (
      <Host class="me-footer">
        <section class="me-footer__section me-footer__section--body">
          <div class="me-footer__body">
            <slot />
          </div>
        </section>
        <section class="me-footer__section me-footer__section--medienhaus">
          <div class={medienhausClassList}>
            <me-button
              variant="link"
              class="me-footer__button me-footer__button--logo"
              href="https://www.medienhaus-main-echo.de/"
              target="_blank"
            >
              <img
                class="me-footer__logo me-footer__logo--light-mode"
                src={getAssetPath('assets/me-footer/logo-medienhaus-light-mode.svg')}
                width={300}
                height={70}
                alt="Medienhaus Main-Echo"
                loading="lazy"
              />
              <img
                class="me-footer__logo me-footer__logo--dark-mode"
                src={getAssetPath('assets/me-footer/logo-medienhaus-dark-mode.svg')}
                width={440}
                height={103}
                alt="Medienhaus Main-Echo"
                loading="lazy"
              />
            </me-button>
            {this.medienhausLinks
              ? (
                <me-button
                  variant="link"
                  class="me-footer__button me-footer__button--link"
                  href="https://www.medienhaus-main-echo.de/"
                  target="_blank"
                >
                  medienhaus-main-echo.de
                </me-button>
              )
              : ''}
          </div>
        </section>
      </Host>
    );
  }
}
